export enum RoleType {
    Owner = 'Owner',
    Contributor = 'Contributor',
}
